module.exports = __webpack_public_path__ + "img/selected5-min.f1e36632.png";